import { DEFAULT_IMAGE_CROPPER } from '../store'

export const SET_IMAGE_CROPPER = 'SET_IMAGE_CROPPER'
export const CLEAN_IMAGE_CROPPER = 'CLEAN_IMAGE_CROPPER'
export const SET_BUSY_IMAGE_CROPPER = 'SET_BUSY_IMAGE_CROPPER'

/**
 * Set image cropper data
 *
 * @param {Object} state
 * @param {Object} data
 * @return {Object}
 */
function setImageCropper(state, data) {
    return {
        ...state,
        ...data,
    }
}

/**
 * Clear image cropper store
 *
 * @param {Object} state
 * @return {Object}
 */
function cleanImageCropper(state) {
    return {
        ...state,
        ...DEFAULT_IMAGE_CROPPER,
    }
}

/**
 * Set busy image cropper
 *
 * @param {Object} state
 * @param {bool} busy
 * @return {Object}
 */
function setBusyImageCropper(state, busy) {
    return {
        ...state,
        busy: busy,
    }
}

/**
 * Reducer for image cropper
 *
 * @param {Object} state
 * @param {Object} action
 * @return {*}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_IMAGE_CROPPER: return setImageCropper(state, action.data)
        case CLEAN_IMAGE_CROPPER: return cleanImageCropper(state)
        case SET_BUSY_IMAGE_CROPPER: return setBusyImageCropper(state, action.busy)
        default: return state
    }
}
